import { useEffect, useState } from 'react';
import api from './api';

/**
 * Whether the Linkly Cloud EFTPOS integration is live.
 * Hits GET /api/linkly/health once on mount and returns a stable boolean.
 * Used to gate every EFTPOS button in the UI so they stay hidden until
 * the merchant configures Linkly creds in the env.
 */
export function useLinklyEnabled() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    api.get('/linkly/health')
      .then(r => { if (alive) setEnabled(!!r.data?.enabled); })
      .catch(() => { if (alive) setEnabled(false); });
    return () => { alive = false; };
  }, []);
  return enabled;
}
